import { cn } from '@/legacy-src/lib/utils'
import Container from '@/legacy-src/rebrand/Container'

import type { CMSMenuItem } from '@/src/domains/cms-menus/schemas'
import { HIDE_HEADER_CLASS } from '@/src/domains/header/constants'

import { HeaderActions } from './HeaderActions'
import { HeaderDesktopLanguagePicker } from './HeaderDesktopLanguagePicker'
import { HeaderDesktopNavigation } from './HeaderDesktopNavigation'
import { HeaderHome } from './HeaderHome/HeaderHome'
import { HeaderMobileMenu } from './HeaderMobileMenu'

export interface HeaderProviderProps {
  isBusiness?: boolean
  displayHearme?: boolean
  menu: CMSMenuItem[]
}

export const Header = ({ isBusiness = false, displayHearme = false, menu }: HeaderProviderProps) => (
  <header
    className={cn('sticky top-0 z-40 py-2', HIDE_HEADER_CLASS, {
      'bg-white': !isBusiness,
      'bg-blue-500': isBusiness,
    })}
  >
    <Container width="xl" className="flex items-center justify-between gap-2">
      <div>
        <HeaderHome isBusiness={isBusiness} displayHearme={displayHearme} />
      </div>
      <HeaderDesktopNavigation menu={menu} isBusiness={isBusiness} />
      <div className="flex items-center gap-2">
        <HeaderDesktopLanguagePicker />
        <HeaderActions isBusiness={isBusiness} />
        <HeaderMobileMenu isBusiness={isBusiness} menu={menu} />
      </div>
    </Container>
  </header>
)
